export enum MicrosoftClaritySessionBumper {
  RequestCtaClicked = 'request_cta_clicked',
  MostPageScrolled = 'most_page_scrolled',
  ContactFormEngagement = 'contact_form_engagement',
  ContactFormSubmit = 'contact_form_submit',
  ContactFormError = 'contact_form_error',
  SocialLinkClicked = 'social_link_clicked',
  EmailClicked = 'email_clicked',
  PhoneBanner = 'phone_clicked',
}
